import type { FaireProductEntity } from "../../entity_types/product";

export const p_7qh8if7n5x: FaireProductEntity = {
  token: "p_7qh8if7n5x",
  type: "product",
  name: "Charcoal Classic Candle",
  brandToken: "b_345v3zg1",
  brandName: "Apotheke",
  imageUrl:
    "https://cdn.faire.com/fastly/05f0f9649f0f4f7013eae289c2b7838946819d2f2a93269370455ac5b46d51b2.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/3677238cab776d9906d18d17468459e7fca61113c2ef23ad2adc1c424ec97d3b.jpeg",
    "https://cdn.faire.com/fastly/d8efc48e915334a305ccc94bc47de2b893d67867dcf15335fbce3e5422a40d6c.jpeg",
  ],
  priceDollars: 23,
  description:
    'Experience the rich and addictive aroma of our broody bestselling fragrance, Charcoal. This Classic Scented Candle is made with a premium soy wax blend and essential and perfume-grade fragrance oils in a chic matte-black glass vessel.\n\n𝐓𝐡𝐞 𝐅𝐫𝐚𝐠𝐫𝐚𝐧𝐜𝐞\nCharcoal combines cedarwood and sandalwood with smoky embers, burnt maple, and a hint of raspberry for a broody and full-bodied fragrance.\n\n𝐓𝐡𝐞 𝐏𝐫𝐨𝐝𝐮𝐜𝐭\nMade with a premium soy wax blend and essential and perfume-grade fragrance oils, this luxury scented candle is designed to provide a clean-burning and exceptional scent experience. All Charcoal Scented Candles feature black wax.\n\n• Net Weight: 10.5 oz. (296 g)\n• Approximate Burn Time: 60-70 hours\n• Candle Dimensions: 3.5" DIA x 3.9" H\n• Fragrance Family: Woody',
  tags: [],
  msrpDollars: 46,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:09.366Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
